import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const COLS = [
  { h: "TradieLoop", links: [["/about", "About us"], ["/how-it-works", "How it works"], ["/faq", "FAQ"], ["/rate-guide", "Rate guide"], ["/contractors", "Find a tradie"], ["/jobs", "Job feed"]] },
  { h: "Legal", links: [["/terms", "Terms of use"], ["/privacy", "Privacy policy"]] },
  { h: "Contact", links: [["mailto:info@tradieloopaus.com.au", "info@tradieloopaus.com.au"]] },
];

export default function Footer() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return (
    <footer className="dark-zone border-t-[5px] border-[#FF6A00] bg-[#0A0A0A] text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-10 grid grid-cols-1 sm:grid-cols-3 gap-8">
        {COLS.map((c) => (
          <div key={c.h}>
            <div className="font-mono-data text-[10px] tracking-widest text-[#FF6A00] uppercase">// {c.h}</div>
            <ul className="mt-3 space-y-2">
              {c.links.map(([to, label]) => (
                <li key={to}>
                  {to.startsWith("mailto:")
                    ? <a href={to} className="text-sm text-zinc-400 hover:text-white" data-testid="footer-contact-email">{label}</a>
                    : <Link to={to} className="text-sm text-zinc-400 hover:text-white" data-testid={`footer-link-${to.replace(/\//g, "") || "home"}`}>{label}</Link>}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/5">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-4 flex flex-col sm:flex-row justify-between gap-2 text-[11px] text-zinc-600 font-mono-data">
          <span>© {new Date().getFullYear()} TradieLoop (Tradie Loop) · Sydney, Australia</span>
          <span>Payments by Stripe · Data hosted in Sydney</span>
        </div>
      </div>
    </footer>
  );
}
